import axios from "axios";
import Vue from "vue";
import loadConfig from "@web3Config/config";
const crypto = require("crypto");
import requestApiCache from "@assets/js/requestApiCache"; // 引入缓存模块
import store from "@store/index";

const Axios = axios.create({
  timeout: 30000, // 请求超时时间
});

// 缓存配置：为每个URL 定义独立的缓存策略
const cacheConfig = {
  // "token/info": { duration: 100000, cacheEnabled: true },
  // "trade/kline": { duration: 5000, cacheEnabled: true },
};

Axios.defaults.baseURL = loadConfig.http_host;
// 添加请求拦截器 缓存策略相关
Axios.interceptors.request.use(
  (config) => {
    let token = store.state["user"]["token"] || "";
    if (token) config.data["_token"] = token;
    const url = config.url;
    console.log("config.url", config.url);
    const cacheOptions = cacheConfig[url] || { cacheEnabled: false }; // 获取缓存配置
    if (cacheOptions.cacheEnabled && config.method === "post") {
      const cacheKey = requestApiCache.generateCacheKey(config);
      const cachedData = requestApiCache.getCache(cacheKey, cacheOptions.duration);
      //响应时存在缓存数据
      if (cachedData) {
        const controller = new AbortController();
        config.signal = controller.signal;
        // 调用 abort() 方法取消请求
        controller.abort();
        //阻止axios发送http请求并抛出异常 在异常中下发缓存数据
        return Promise.reject(new axios.Cancel(`${url}-||-${cacheKey} -||- ${JSON.stringify(cachedData)}`));
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// 添加响应拦截器 缓存策略相关
Axios.interceptors.response.use(
  (res) => {
    const url = res.config.url;
    const cacheOptions = cacheConfig[url] || { cacheEnabled: false }; // 获取缓存配置
    if (cacheOptions.cacheEnabled && res.config.method === "post") {
      const cacheKey = requestApiCache.generateCacheKey(res.config);
      const cachedData = requestApiCache.getCache(cacheKey, cacheOptions.duration);
      requestApiCache.setCache(cacheKey, cachedData ? cachedData : res.data, cacheOptions.duration);
    }

    return res.data;
  },
  (err) => {
    const cacheData = err.message.split("-||-");
    if (err.message && cacheData && cacheData.length >= 2) {
      //下发缓存数据
      // console.log(`读取缓存并下发: ${cacheData[0]} 缓存信息 key:${cacheData[1]} 数据:`, cacheData[2]);
      return JSON.parse(cacheData[2]);
    }
    _v.$toasted.clear();
    // _v.$toasted.error(`${Vue.prototype.$lang("network error")}`);
    return Promise.resolve(null);
  }
);

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: (Vue) =>
    Object.defineProperty(Vue.prototype, "$http", {
      value: Axios,
    }),
  Axios,
};
